export default __webpack_public_path__ + "static/media/southafrica.26888d0a.png";